import { selectOrganizer, selectSynchronization } from 'modules/stream/store/game-info/selectors';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFetchAvailableFeature } from 'shared/hooks/fetchering/use-fetch-available-feature';
import { UDText } from 'ud-ui/components';
import supabase from '../../../core/supabase/supabase';

import { CanvasEventBoards } from '../components/canvas/canvas-event-boards';
import { CanvasStaticBoards } from '../components/canvas/canvas-static-boards';
import Joystick from '../components/joystick/joystick';
import useInitOverlay from '../hooks/initializers/use-init-overlay';

function Overlay() {
  useInitOverlay();

  useEffect(() => {
    window.onerror = function (msg, url, line, col, error) {
      supabase.overlayLogs.createError({
        comment: 'overlay - общий',
        message: error?.stack ?? msg.toString(),
      });
    };
  }, []);

  const organizer = useSelector(selectOrganizer);
  const { isSynchronize: isOrganizerInfoFetched } = useSelector(selectSynchronization);
  const {
    data: feature,
    isLoading: isFeatureLoading,
    error,
  } = useFetchAvailableFeature({
    userTournamentId: organizer?.id,
    isEnabled: isOrganizerInfoFetched,
  });

  useEffect(() => {
    const rootDiv = document.getElementById('root');
    const body = document.getElementsByTagName('body')[0];
    rootDiv?.setAttribute('style', 'background: unset');
    body?.setAttribute('style', 'background: unset; overflow: hidden');
  }, []);

  if (isFeatureLoading || !isOrganizerInfoFetched)
    return (
      <div className={'d-flex items-center justify-center'} style={{ width: '100%', height: '100vh' }}>
        <div className={'d-flex center flex flex-col gap-2 rounded-2xl bg-Red p-4 text-center'}>
          <UDText isNew type={'title-1'}>
            Загрузка, подождите
          </UDText>
          <UDText isNew type={'subtitle-3'}>
            При плохом соединении загрузка может занимать несколько минут
          </UDText>
        </div>
      </div>
    );

  if (error)
    return (
      <div className={'d-flex items-center justify-center'} style={{ width: '100%', height: '100vh' }}>
        <div className={'d-flex center rounded-2xl bg-Red p-4'}>
          <UDText isNew type={'title-1'}>
            Произошла ошибка: {(error as Error)?.message}
          </UDText>
        </div>
      </div>
    );

  if (!feature?.OBS_INTEGRATION && isOrganizerInfoFetched) {
    return (
      <div className={'d-flex items-center justify-center'} style={{ width: '100%', height: '100vh' }}>
        <div className={'rounded-2xl bg-Red p-4'}>
          <UDText isNew type={'title-1'}>
            Подписка не активирована
          </UDText>
        </div>
      </div>
    );
  }

  return (
    <div key={'overlay'} className={'d-flex justify-content-end'} style={{ width: '100%', height: '100vh' }}>
      <div
        className={'d-flex justify-content-end'}
        style={{
          background: 'unset',
          width: '100%',
          height: '100%',
          position: 'relative',
        }}
      >
        <CanvasStaticBoards />
        <CanvasEventBoards />
      </div>
      {feature?.OBS_INTEGRATION && <Joystick key={'FullSizeControlPanel-old'} />}
    </div>
  );
}

export default Overlay;
